<template>
  <div class="dashboard">
    <!-- 欢迎消息和日期 -->
    <div class="bg-white p-6 mb-6">
      <div class="flex items-center justify-between">
        <div>
          <h1 class="text-xl font-medium text-gray-800">待办任务</h1>
          <p class="text-gray-600 mt-2">欢迎回来，张三。这是您今日的任务概览。</p>
        </div>
      </div>
    </div>
    
    <!-- 通知横幅 -->
    <div class="bg-pink-50 border border-pink-100 rounded-lg p-4 mb-6 flex items-center">
      <svg class="w-5 h-5 text-primary mr-3 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"></path>
      </svg>
      <span class="text-gray-700">查看和管理您的待办任务和通知</span>
    </div>

    <!-- 统计卡片 -->
    <div class="grid grid-cols-1 md:grid-cols-4 gap-6 mb-6">
      <!-- 待处理任务 -->
      <div class="bg-white rounded-lg p-6 shadow-sm">
        <div class="flex items-start justify-between">
          <div class="bg-red-100 p-3 rounded-full">
            <svg class="w-6 h-6 text-primary" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2"></path>
            </svg>
          </div>
          <div class="text-right">
            <div class="text-gray-500 text-sm">待处理任务</div>
            <div class="flex items-center justify-end mt-1">
              <div class="text-3xl font-bold text-gray-800">24</div>
              <div class="ml-2 px-2 py-1 bg-green-100 text-green-700 text-xs rounded-full flex items-center">
                <svg class="w-3 h-3 mr-1" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 10l7-7m0 0l7 7m-7-7v18"></path>
                </svg>
                12%
              </div>
            </div>
          </div>
        </div>
        <div class="mt-4">
          <button class="text-primary text-sm hover:underline flex items-center">
            查看全部
            <svg class="w-4 h-4 ml-1" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7"></path>
            </svg>
          </button>
        </div>
      </div>

      <!-- 本月积分 -->
      <div class="bg-white rounded-lg p-6 shadow-sm">
        <div class="flex items-start justify-between">
          <div class="bg-blue-100 p-3 rounded-full">
            <svg class="w-6 h-6 text-blue-500" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z"></path>
            </svg>
          </div>
          <div class="text-right">
            <div class="text-gray-500 text-sm">本月积分</div>
            <div class="flex items-center justify-end mt-1">
              <div class="text-3xl font-bold text-gray-800">86</div>
              <div class="ml-2 px-2 py-1 bg-green-100 text-green-700 text-xs rounded-full flex items-center">
                <svg class="w-3 h-3 mr-1" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 10l7-7m0 0l7 7m-7-7v18"></path>
                </svg>
                8%
              </div>
            </div>
          </div>
        </div>
        <div class="mt-4">
          <button class="text-primary text-sm hover:underline flex items-center">
            查看详情
            <svg class="w-4 h-4 ml-1" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7"></path>
            </svg>
          </button>
        </div>
      </div>

      <!-- 今日会议 -->
      <div class="bg-white rounded-lg p-6 shadow-sm">
        <div class="flex items-start justify-between">
          <div class="bg-green-100 p-3 rounded-full">
            <svg class="w-6 h-6 text-green-500" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"></path>
            </svg>
          </div>
          <div class="text-right">
            <div class="text-gray-500 text-sm">今日会议</div>
            <div class="flex items-center justify-end mt-1">
              <div class="text-3xl font-bold text-gray-800">3</div>
              <div class="ml-2 text-gray-500 text-xs">
                下一个: 14:30
              </div>
            </div>
          </div>
        </div>
        <div class="mt-4">
          <button class="text-primary text-sm hover:underline flex items-center">
            查看日程
            <svg class="w-4 h-4 ml-1" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7"></path>
            </svg>
          </button>
        </div>
      </div>

      <!-- 未读通知 -->
      <div class="bg-white rounded-lg p-6 shadow-sm">
        <div class="flex items-start justify-between">
          <div class="bg-purple-100 p-3 rounded-full">
            <svg class="w-6 h-6 text-purple-500" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 17h5l-1.405-1.405A2.032 2.032 0 0118 14.158V11a6.002 6.002 0 00-4-5.659V5a2 2 0 10-4 0v.341C7.67 6.165 6 8.388 6 11v3.159c0 .538-.214 1.055-.595 1.436L4 17h5m6 0v1a3 3 0 11-6 0v-1m6 0H9"></path>
            </svg>
          </div>
          <div class="text-right">
            <div class="text-gray-500 text-sm">未读通知</div>
            <div class="flex items-center justify-end mt-1">
              <div class="text-3xl font-bold text-gray-800">7</div>
              <div class="ml-2 text-gray-500 text-xs">
                最新: 10分钟前
              </div>
            </div>
          </div>
        </div>
        <div class="mt-4">
          <button class="text-primary text-sm hover:underline flex items-center">
            查看通知
            <svg class="w-4 h-4 ml-1" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7"></path>
            </svg>
          </button>
        </div>
      </div>
    </div>

    <!-- 任务列表 -->
    <div class="bg-white rounded-lg shadow-sm mb-6">
      <div class="border-b p-6 flex justify-between items-center">
        <h2 class="text-lg font-medium text-gray-800">待办任务</h2>
        <div class="flex space-x-2">
          <button class="px-3 py-1 bg-red-50 rounded-full text-primary text-sm font-medium">今日</button>
          <button class="px-3 py-1 bg-gray-100 rounded-full text-gray-500 text-sm font-medium">本周</button>
          <button class="px-3 py-1 bg-gray-100 rounded-full text-gray-500 text-sm font-medium">全部</button>
        </div>
      </div>
      
      <div class="p-6">
        <div class="flex justify-between items-center mb-4">
          <h3 class="text-gray-600 font-medium">积分初审</h3>
          <div class="text-sm text-primary">快捷操作</div>
        </div>
        
        <!-- 任务项 1 -->
        <div class="border rounded-lg p-4 mb-4 hover:shadow-md transition-shadow">
          <div class="flex items-start">
            <div class="mr-4 mt-1">
              <svg class="w-6 h-6 text-primary" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2"></path>
              </svg>
            </div>
            <div class="flex-1">
              <div class="flex justify-between items-start">
                <div>
                  <h4 class="text-gray-800 font-medium">积分初审</h4>
                  <p class="text-gray-500 text-sm mt-1">12条待审核记录</p>
                </div>
                <button class="px-4 py-2 bg-primary text-white rounded-md text-sm hover:bg-red-600 transition-colors">
                  去处理
                </button>
              </div>
            </div>
          </div>
        </div>
        
        <!-- 任务项 2 -->
        <div class="border rounded-lg p-4 mb-4 hover:shadow-md transition-shadow">
          <div class="flex items-start">
            <div class="mr-4 mt-1">
              <svg class="w-6 h-6 text-blue-500" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"></path>
              </svg>
            </div>
            <div class="flex-1">
              <div class="flex justify-between items-start">
                <div>
                  <h4 class="text-gray-800 font-medium">积分终审</h4>
                  <p class="text-gray-500 text-sm mt-1">5条待审核记录</p>
                </div>
                <button class="px-4 py-2 bg-blue-500 text-white rounded-md text-sm hover:bg-blue-600 transition-colors">
                  去处理
                </button>
              </div>
            </div>
          </div>
        </div>
        
        <!-- 任务项 3 -->
        <div class="border rounded-lg p-4 hover:shadow-md transition-shadow">
          <div class="flex items-start">
            <div class="mr-4 mt-1">
              <svg class="w-6 h-6 text-yellow-500" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"></path>
              </svg>
            </div>
            <div class="flex-1">
              <div class="flex justify-between items-start">
                <div>
                  <h4 class="text-gray-800 font-medium">异议处理</h4>
                  <p class="text-gray-500 text-sm mt-1">3条待处理异议</p>
                </div>
                <button class="px-4 py-2 bg-yellow-500 text-white rounded-md text-sm hover:bg-yellow-600 transition-colors">
                  去处理
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Dashboard',
  data() {
    return {
      date: new Date(),
      stats: {
        pendingTasks: 24,
        pendingTasksGrowth: 12,
        monthlyPoints: 86,
        monthlyPointsGrowth: 8,
        todayMeetings: 3,
        nextMeetingTime: '14:30',
        unreadNotifications: 7,
        lastNotificationTime: '10分钟前'
      }
    }
  },
  computed: {
    formattedDate() {
      const year = this.date.getFullYear()
      const month = this.date.getMonth() + 1
      const day = this.date.getDate()
      return `${year}年${month}月${day}日`
    }
  },
  methods: {
    // 处理任务请求
    handleTaskAction(type) {
      console.log('处理任务:', type)
      // 实际项目中这里会跳转到相应的处理页面
    }
  }
}
</script>

<style scoped>
/* 自定义样式 */
</style>
